import { isWeightedItem } from "../utils/product.mjs";
import { PRODUCT_CONTEXT } from "../utils/provides.mjs";
import { clone, isEmpty } from "lodash-es";
import { computed, inject, onMounted, watch } from "vue";
import { useState } from "#app";
export function useStoredProduct() {
  const product = useState("product-context", () => ({
    id: 0,
    type: "SimpleProduct",
    variants: void 0,
    isNew: false,
    stock: 0,
    price: 0,
    bundleItems: void 0,
    groupItems: void 0,
    cartControl: {
      max: 0,
      min: 0,
      step: 1,
      unit: ""
    },
    short_description: {
      html: ""
    },
    attributes: [],
    special_to_date: void 0,
    special_from_date: void 0,
    configurationOptions: void 0,
    dynamicPrice: false,
    mainCategory: "",
    media_gallery: [],
    price_range: void 0,
    priceBefore: 0,
    rating_summary: 0,
    review_count: 0,
    special_price: void 0,
    description: {
      html: ""
    },
    name: "",
    categories: [],
    sku: "",
    thumbnail: {},
    parentSku: "",
    image: {},
    brand: {
      name: ""
    },
    meta_description: "",
    meta_keywords: "",
    meta_title: "",
    url_key: "",
    configurableGiftBoxOptionId: void 0,
    heroImage: "",
    simpleGiftBoxOptionId: void 0,
    value: 0,
    deliveryCondition: ""
  }));
  return {
    product
  };
}
export function useInitProductContext(_useStoredProduct = useStoredProduct) {
  const { product } = _useStoredProduct();
  const productCtx = inject(PRODUCT_CONTEXT);
  watch(
    productCtx,
    (newCtx) => {
      product.value = clone(newCtx);
    },
    {
      immediate: true
    }
  );
  onMounted(() => {
    if (!product.value?.id)
      product.value = clone(productCtx.value);
  });
}
export function useProductContext(opts = {
  init: false
}, _useInitProductContext = useInitProductContext) {
  const { product } = useStoredProduct();
  const productCtx = inject(PRODUCT_CONTEXT);
  const _productCtx = computed(() => productCtx.value);
  if (opts.init)
    _useInitProductContext();
  function appendProductValues(attributes) {
    if (attributes === null || isEmpty(attributes)) {
      return;
    }
    product.value = {
      ...product.value,
      ...attributes
    };
  }
  return {
    product: computed(() => product.value),
    productCtx: _productCtx,
    appendProductValues,
    isWeightedItem: computed(() => isWeightedItem(product.value))
  };
}
export function useProductGiftWrappingContext() {
  const giftWrappingComment = useState("giftWrappingComment", () => "");
  return {
    giftWrappingComment
  };
}
